let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ebjt1")).then(() => parcelRequire('dXRKt'));